import type { NavigationGuardNext, RouteLocationNormalized, Router } from 'vue-router';

export default async function urlToken({
  to,
  from,
  next,
  router
}: {
  to: RouteLocationNormalized;
  from: RouteLocationNormalized;
  next: NavigationGuardNext;
  router: Router;
}) {
  const user = useUserStore();
  if (to.query.token) {
    user.isLogin = true;
    user.token = to.query.token as string;
  }
  return next();
}
